import { formatDateTime } from "../scholarships/review/model";

const stepLabel = (step) => (step.charAt(0) + step.slice(1).toLowerCase().replaceAll("_", " ")).replace(/\b(dg|hec|brd)\b/gi, (m) => m.toUpperCase());

// Every step an abroad loan application went through, oldest first
export default function AbroadHistory({ history }) {
  if (!history.length) return <p className="text-sm text-slate-500">Nothing has happened yet.</p>;
  return (
    <ol className="flex flex-col gap-2 text-sm">
      {history.map((s, i) => (
        <li key={i} className="flex flex-wrap gap-x-3">
          <span className="text-slate-500">{formatDateTime(s.at)}</span>
          <span className="font-medium text-slate-800">{stepLabel(s.step)}</span>
          {s.note && <span className="italic text-slate-600">“{s.note}”</span>}
        </li>
      ))}
    </ol>
  );
}
